import { render, staticRenderFns } from "./FormTabelaValor.vue?vue&type=template&id=126d696a"
import script from "./FormTabelaValor.vue?vue&type=script&lang=js"
export * from "./FormTabelaValor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports